// oxlint-disable-next-line typescript/no-explicit-any
export const couldBeNumber = (v?: any) => isFinite(v) && !isNaN(parseFloat(v));
